import React from 'react'
import styles from './Modal.module.css'


const Modal = (props) => {

    const {mostrarModal, setModal} = props;

    function cerrarModal(data) {
        setModal(data)
    }

    function miFuncion() {
        props.accion()
        cerrarModal(false)
    }

    return (
        <div>
            <div className={mostrarModal ? `${styles['w3-modal']} ${styles['show-modal-beneficiaries']}` : `${styles['w3-modal']} ${styles['hide-modal-beneficiaries']}`}>
                <div className={styles['w3-modal-content']}>
                    <div className={styles['w3-header']}>
                    </div>
                    <div className={styles['w3-container']}>
                        <p className={styles['w3title']}>{props.textos[0]}</p>
                        <div className={`${styles['grupo-de-form']} ${styles['top-18']}`}>
                            <div className={styles['area-50']}>
                                <label style={props.estilos !== undefined ? props.estilos : {}}>{props.textos[1]}</label>
                            </div>
                        </div>    
                        {props.doble ?
                            <div className={styles['w3areabtn']}>
                                <button className={`${styles['btn-pago-accion']}`} onClick = {()=>miFuncion()} >
                                    Aceptar
                                </button>
                                <button className={`${styles['btn-cancelar']} ${styles['w3-margen']}`} onClick = {()=>cerrarModal(false)}>
                                    Cancelar
                                </button>
                            </div>  
                            :
                            <div className={styles['w3areabtn']}>
                                <button style={{width: '60%'}} className={`${styles['btn-pago-accion']}`} onClick = {()=>cerrarModal(false)}>
                                    Aceptar
                                </button>
                            </div>
                        }        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Modal;